import * as React from "react";

import "./product-category-route.scss";

import {cs}                         from "@Common/react/chain-services";
import {consumeContext}             from "@Common/react/context";
import {flatten1, sort}             from "@Common/utils/collections";
import {chain}                      from "@Common/utils/fs";
import {isEmpty, oMapToArr}         from "@Common/utils/objects";
import {SubHeader}                  from "@Xpresso/routes/common/sub-header/sub-header";
import {rProductTiles}              from "../../../common/tiles/product-tiles";
import {Layout}                     from "../../../layout/layout";
import {rTemplateViewMore}          from "../../common/template-view-more";

export const ProductCategoryRoute = ({}) => cs(
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("userCreatedCatSubStyle"),
    consumeContext("routerHistory"),
    ["products", ({userCreatedCatSubStyle}, next) => next(userCreatedCatSubStyle?.value)],
    ({apis, company, products, routerHistory}) => {
        return (
            <Layout className="product-category-route-9at" active="catSubcatStyle">
                <SubHeader
                    backLink={
                        <a
                            onClick={() => routerHistory.goBack()}
                            className="back"
                            xd-qa-type="link"
                            xd-qa-name="Back"
                        >
                            <i className="fa fa-chevron-left"/> Back
                        </a>
                    }
                    title="Select Product"
                />
                <div className="restrict-width-1">
                    {products == null ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Loading">
                            Loading...
                        </div>
                    )  : isEmpty(products) ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Empty">
                            No products are available!
                        </div>
                    ) : (Object.entries(products).map(([catId, cat]) => {
                            return rProductTiles({
                                products: sort(cat.child, (sub: any) => sub.seq),
                                getProductViewData: (sub) => ({
                                    img_url: sub.image,
                                    name: sub.name,
                                    type: 'userCreated',
                                    to: `/manage-templates/product/${catId}/${sub.id}`,
                                    new_tab: undefined,
                                    getIcon: () => company?.prefs.smartTemplateIcon && sub.hasCCTemplate && (
                                        <div className="icon" xd-qa-type="icon" xd-qa-name="Smart Template Icon">
                                            <img alt="Smart Template" src="/next_images/icons/SmartTemplateIcon.svg"/>
                                        </div>
                                    ),
                                    children: sort(sub.child, (style: any) => style.seq).map((style) => ({
                                        name: style.name,
                                        to: `/manage-templates/product/${sub.id}?filter=${style.id}`,
                                    })),
                                }),
                                view_more: {
                                    getItems: async (sub) => {
                                        const styleTemplates = await apis.next.getStyleTemplate([sub.id]);
                                        return chain(
                                            flatten1(oMapToArr(styleTemplates, s=>s.templates)),
                                            (_) => sort(_, (template: any) => template.seq),
                                        );
                                    },
                                    renderItem: (template, {viewMode}) => rTemplateViewMore(template, true, {viewMode}),
                                    alwaysShow: true,
                                },
                            })
                        })
                    )}
                </div>
            </Layout>
        );
    },
);